module.exports = __webpack_public_path__ + "public/img/Bahasa Inggris Untuk Administrasi Dan Legalitas Perkantoran.7c8c22cd.png";